export default class DtoWaterMass {
    constructor(code, europeanCode, name) {
        this.code = code
        this.europeanCode = europeanCode
        this.name = name
    }
}